/**
 * 订单中心API
 */
import http from './http'

class MyorderApi {
    //获取订单列表
    static getOrderList(params) {
        return http.httpPost('order/getOrderList',params);
    }
    static fpList(params) {
        return http.httpPost('order/fp/list',params);
    }


}

export default MyorderApi;



// WEBPACK FOOTER //
// ./app/api/myorder.api.js